import { action } from 'mobx';
import Collection from 'core/model/Collection';

import KentikAgentClusterModel from './KentikAgentClusterModel';

export default class KentikAgentClusterCollection extends Collection {
  _clusterByGroupID = {};

  get url() {
    return '/api/ui/kentik-agent/clusters';
  }

  get defaultSortState() {
    return {
      field: 'cluster.displayName',
      direction: 'asc'
    };
  }

  @action
  processData(response) {
    this._clusterByGroupID = {};
    this._clusterDataByClusterID = {};
    response.forEach((clusterData) => {
      const { cluster, groups } = clusterData;
      groups.forEach(({ group }) => {
        this._clusterByGroupID[group.groupId] = { ...cluster };
      });
      const { clusterId } = cluster;
      this._clusterDataByClusterID[clusterId] = clusterData;
    });

    return super.processData(response);
  }

  findByClusterDataId(clusterId) {
    const key = typeof clusterId === 'string' ? Number(clusterId) : clusterId;
    return this._clusterDataByClusterID[key] || null;
  }

  get model() {
    return KentikAgentClusterModel;
  }
}
